<ng-container *ngIf="{
  searchOptions: searchOptions$ | async,
  pageRowsCount: pageRowsCount$ | async,
  totalRowsCount : totalRowsCount$ | async} as data">

  <!-- Summary + page size selector -->
  <div class="results-pane-title" *ngIf="data.totalRowsCount > 0">
    <div class="page-size-text">Showing {{ data.pageRowsCount }} of {{ data.totalRowsCount }} recipients</div>
    <mat-form-field appearance="outline" class="remove-error-place">
      <mat-select [formControl]="perPageControl">
        <mat-option *ngFor="let amountPerPage of paymentsPerPage" [value]="amountPerPage">{{amountPerPage}} per page
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Data table -->
  <table mat-table [dataSource]="dataSource" [trackBy]="trackByFunction" class="gray-theme mat-elevation-z0" matSort
    matSortDisableClear (matSortChange)="sortData($event)" [matSortDirection]="data.searchOptions.sortOrder"
    [matSortActive]="data.searchOptions.orderBy" multiTemplateDataRows>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="PaymentSentTimestamp" class="date-col-header">Date</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive date-cell">
        {{ element.paymentSentTimestamp | date }}
      </td>
    </ng-container>

    <!-- Account name Column -->
    <ng-container matColumnDef="accountName">
      <th mat-header-cell *matHeaderCellDef class="account-name-col-header">Account Name</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive account-name-cell">
        {{ element.sourceBankAccountName }}
      </td>
    </ng-container>

    <!-- Category Column -->
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef class="category-col-header desktop">Category</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive category-cell desktop">
        {{ element.category | enumString: crePaymentCategory }}
      </td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="description-col-header desktop">Description</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive description-cell desktop">
        {{ element.description }}
      </td>
    </ng-container>

    <!-- Amount Column -->
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="Amount" class="amount-col-header desktop">Amount</th>
      <td mat-cell *matCellDef="let element" class="amount-column-content desktop">
        ${{ element.amount | number }}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="repeat">
      <th mat-header-cell *matHeaderCellDef class="actions-col-header desktop"></th>
      <td mat-cell *matCellDef="let payment" class="actions desktop">
        <button *ngIf="repeatPayment && repeatPayment.observers.length > 0"
          (click)="onRepeat(payment); $event.stopPropagation(); (false)" mat-flat-button class="replay-button">
          <mat-icon class="notranslate">replay</mat-icon>
          Repeat
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions" class="mobile">&nbsp;</th>
      <td mat-cell *matCellDef="let element" class="mobile">
        <button mat-icon-button aria-label="expand row"
          (click)="(expandedElement = expandedElement === element.id ? null : element.id); $event.stopPropagation()">
          <mat-icon *ngIf="expandedElement !== element.id">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="expandedElement === element.id">keyboard_arrow_up</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="mobile">
        <div class="expanded-element-detail" [@detailExpand]="expandedElement === element.id? 'expanded' : 'collapsed'">
          <div class="expanded-element"> <span class="expanded-element-header">Amount:</span>
            ${{ element.amount | number }}
          </div>
          <div class="expanded-element"> <span class="expanded-element-header">Category:</span>
            {{ element.category }}
          </div>
          <div class="expanded-element"> <span class="expanded-element-header">Description:</span>
            {{ element.description }}
          </div>
          <button *ngIf="repeatPayment && repeatPayment.observers.length > 0" class="replay-button"
            (click)="onRepeat(element); $event.stopPropagation(); (false)" mat-flat-button>
            <mat-icon class="notranslate">replay</mat-icon>
            Repeat
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.hide]="isLoading$ | async"
      (mouseover)="row.hover = true" (mouseout)="row.hover = false" class="value-row"
      [class.payment-expanded-row]="expandedElement === row.id"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="payment-detail-row mobile"></tr>
  </table>

  <!-- loader  -->
  <terra-loader *ngIf="isLoading$ | async" class="loader"></terra-loader>

  <!-- Empty state -->
  <div class="empty-list-message" *ngIf="!(isLoading$ | async) && data.totalRowsCount == 0">
    <p>No payments found.</p>
  </div>

  <mat-paginator (page)="pageChange($event)" [length]="data.totalRowsCount" [hidePageSize]="true"
    [pageSize]="data.searchOptions.pageSize" [pageIndex]="data.searchOptions.pageNumber"
    *ngIf="data.totalRowsCount > 0"></mat-paginator>
</ng-container>